<template>
<div class=""
	 v-if="webcastEntry && webcastEntry.type !==1"
	 style="width: 100%;"
	 data-scp="webcastEntry.0">
	<a href="/webcast.html#/publicity"
	   class="border-radius"
	   @click="goApp($event)"
	   v-if="!isWeixin">
		<div class="margint20 marginh20 border radius flex-container"
			 style="background: #fff4f5;padding-right: 8px;height: 52px;border-width: 0;"
			 v-if="!showStore">
			<div class="flex-container marginr10 overflow-h">
				<div class="text-white fs-11"
					 style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(270deg, #FF6100 0%, #FF2238 100%);">
					<img style="position: relative;top: -2px;" src="//image1.51tiangou.com/tgou2/img2/webcast/casting.gif" width="16" height="16" alt="">
					直播中</div>
				<div style="margin-left: 8px;">
					<div class="fs-14 text-bolder text-limit2">大商天狗直播间</div>
					<div class="fs-11 text-limit1" style="margin-top: 2px;color:#666;">专柜直发正品保障</div>
				</div>
			</div>
			<div class="pill badge red reverse fs-12"
				 style="width: 80px;padding: 0;flex-shrink: 0;border-color: #ff2238;background: transparent;color: #ff2238;line-height: 22px;">超值不等待<i class="icon-right"></i></div>
		</div>
		<div class="margint20 marginh20 border radius flex-container"
		     style="background: #fff4f5;padding-right: 8px;height: 52px;border-width: 0;"
		     v-if="webcastEntry.type===4 && showStore">
			<div class="flex-container marginr10 overflow-h">
				<div class="text-white fs-11"
				     style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(270deg, #FF6100 0%, #FF2238 100%);">
					<img style="position: relative;top: -2px;" src="//image1.51tiangou.com/tgou2/img2/webcast/casting.gif" width="16" height="16" alt="">
					直播中</div>
				<div style="margin-left: 8px;">
					<div class="fs-14 text-bolder text-limit2" v-text="webcastEntry.name"></div>
				</div>
			</div>
			<div class="pill badge red reverse fs-12"
			     style="width: 80px;padding: 0;flex-shrink: 0;border-color: #ff2238;background: transparent;color: #ff2238;line-height: 22px;">超值不等待<i class="icon-right"></i></div>
		</div>
		<div class="margint20 marginh20 border radius flex-container"
			 style="background: #effff5;padding-right: 8px;height: 52px;border-width: 0;"
			 v-if="webcastEntry.type===3 && showStore">
			<div class="flex-container marginr10 overflow-h">
				<div class="text-white fs-11"
					 style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(90deg, #16CC90 0%, #14C29F 100%)">
					<img style="position: relative;top: -2px;" src="//image1.51tiangou.com/tgou2/img2/webcast/replay.png" width="16" height="16" alt="">
					直播回放</div>
				<div style="margin-left: 8px;">
					<div class="fs-14 text-bolder text-limit2" v-text="webcastEntry.name"></div>
				</div>
			</div>
			<div style="flex-shrink: 0;">
				<img src="//image1.51tiangou.com/tgou2/img2/webcast/find.gif" width="80" height="24" alt="">
			</div>
		</div>
		<div class="margint20 marginh20 border radius flex-container"
			 style="background: #f1f6ff;padding-right: 8px;height: 52px;border-width: 0;"
			 v-if="webcastEntry.type===2 && showStore">
			<div class="flex-container marginr10 overflow-h">
				<div class="text-white fs-11"
					 style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(270deg, #00CCFF 0%, #0A5DF1 100%)">
					<img style="position: relative;top: -2px;" src="//image1.51tiangou.com/tgou2/img2/webcast/foreshow.png" width="16" height="16" alt="">
					直播预告</div>
				<div style="margin-left: 8px;">
					<div class="fs-14 text-bolder text-limit1" v-text="webcastEntry.name"></div>
					<div class="fs-11 text-limit1" style="margin-top: 2px;color:#666;" v-text="countdown"></div>
				</div>
			</div>
			<div style="flex-shrink: 0;">
				<img src="//image1.51tiangou.com/tgou2/img2/webcast/weal.gif" width="80" height="24" alt="">
			</div>
		</div>
	</a>
	<div v-else v-html="wxapp"></div>
</div>
</template>

<script>
import {maple, domain, app} from 'tgPage';

export default {
	name: 'webcastEntry'
	, props: {
		webcastEntry: {
			type: Object
			, default: null
		}
		, showStore: {
			type: Boolean
			, default: true
		}
		, storeId: {
			type: String
			, default: ''
		}
	}
	, data(){
		return {
			isWeixin: maple.device.weixin
			, isHybrid: maple.cookie('hybrid') === 'true'
			, webcast: {
				userName: domain.webcast.userName
				, path: domain.webcast.path +'.html'
			}
			, protocol: location.protocol
		};
	}
	, methods: {
		goApp($event){
			if( this.isHybrid ){
				$event.preventDefault();

				app.startWxapp( domain.webcast );
			}
		}
	}
	, computed: {
		countdown(){
			if( !this.webcastEntry || this.webcastEntry.type !== 2 ){
				return '';
			}

			let d = this.webcastEntry.startTime - Date.now()
				, h = Math.floor( d/(3600*1000) )
				, m = Math.floor( (d%(3600*1000))/60000 )
			;

			if( d <= 0 ){
				return '';
			}

			if( h ){
				return `${h}小时${m}分钟后开始`;
			}
			else{
				return `${m}分钟后开始`;
			}
		}
		, path(){
			if( this.storeId ){
				return `/subpackages/customer/lives/storeliveslist/storeliveslist.html?storeId=${this.storeId}`;
			}
			else{
				return `${domain.webcast.path}.html`;
			}
		}
		, wxapp(){
			let content = ''
				;

			if( !this.showStore ){
				content = `<div class="margint20 marginh20 border radius flex-container"
                 style="background: #fff4f5;padding-right: 8px;height: 52px;border-width: 0;">
                <div class="flex-container marginr10 overflow-h">
                   	<div class="text-white fs-11"
                         style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(270deg, #FF6100 0%, #FF2238 100%);">
                        <img style="position: relative;top: -2px;" src="${this.protocol}//image1.51tiangou.com/tgou2/img2/webcast/casting.gif" width="16" height="16" alt="">
                        直播中</div>
                    <div style="margin-left: 8px;">
                        	<div class="fs-14 text-bolder text-limit2">大商天狗直播间</div>
					<div class="fs-11 text-limit1" style="margin-top: 2px;color:#666;">专柜直发正品保障</div>
                    </div>
                </div>
                <div class="pill badge red reverse fs-12"
                     style="width: 80px;padding: 0;float: right;flex-shrink: 0;border-color: #ff2238;background: transparent;color: #ff2238;line-height: 22px;">超值不等待&gt;</div>
            </div>`;
			}
			else if( this.webcastEntry.type === 4 ){
				content = `<div class="margint20 marginh20 border radius flex-container"
                 style="background: #fff4f5;padding-right: 8px;height: 52px;border-width: 0;">
                <div class="flex-container marginr10 overflow-h">
                    <div class="text-white fs-11"
                         style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(270deg, #FF6100 0%, #FF2238 100%);">
                        <img style="position: relative;top: -2px;" src="${this.protocol}//image1.51tiangou.com/tgou2/img2/webcast/casting.gif" width="16" height="16" alt="">
                        直播中</div>
                    <div style="margin-left: 8px;">
                        <div class="fs-14 text-bolder text-limit2">${this.webcastEntry.name}</div>
                    </div>
                </div>
                <div class="pill badge red reverse fs-12"
                     style="width: 80px;padding: 0;float: right;flex-shrink: 0;border-color: #ff2238;background: transparent;color: #ff2238;line-height: 22px;">超值不等待&gt;</div>
            </div>`;
			}
			else if( this.webcastEntry.type === 3 ){
				content = `<div class="margint20 marginh20 border radius flex-container"
                 style="background: #effff5;padding-right: 8px;height: 52px;border-width: 0;">
                <div class="flex-container marginr10 overflow-h">
                    <div class="text-white fs-11"
                         style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(90deg, #16CC90 0%, #14C29F 100%)">
                        <img style="position: relative;top: -2px;" src="${this.protocol}//image1.51tiangou.com/tgou2/img2/webcast/replay.png" width="16" height="16" alt="">
                        直播回放</div>
                    <div style="margin-left: 8px;">
                        <div class="fs-14 text-bolder text-limit2">${this.webcastEntry.name}</div>
                    </div>
                </div>
                <div style="flex-shrink: 0;float: right;">
                    <img src="${this.protocol}//image1.51tiangou.com/tgou2/img2/webcast/find.gif" width="80" height="24" alt="">
                </div>
            </div>`;
			}
			else if( this.webcastEntry.type === 2 ){
				content = `<div class="margint20 marginh20 border radius flex-container"
                 style="background: #f1f6ff;padding-right: 8px;height: 52px;border-width: 0;">
                <div class="flex-container marginr10 overflow-h">
                    <div class="text-white fs-11"
                         style="flex-shrink: 0;line-height: 20px;border-radius: 0 4px 4px 0;padding: 0 4px;background-image: linear-gradient(270deg, #00CCFF 0%, #0A5DF1 100%)">
                        <img style="position: relative;top: -2px;" src="${this.protocol}//image1.51tiangou.com/tgou2/img2/webcast/foreshow.png" width="16" height="16" alt="">
                        直播预告</div>
                    <div style="margin-left: 8px;">
                        <div class="fs-14 text-bolder text-limit1">${this.webcastEntry.name}</div>
                        <div class="fs-11 text-limit1" style="margin-top: 2px;color:#666;">${this.countdown}</div>
                    </div>
                </div>
                <div style="flex-shrink: 0;float: right;">
                    <img src="${this.protocol}//image1.51tiangou.com/tgou2/img2/webcast/weal.gif" width="80" height="24" alt="">
                </div>
            </div>`;
			}

			return `<wx-open-launch-weapp
						style="display: block;"
						id="webcastEntry"
 						username="${this.webcast.userName}"
                        path="${this.path}">
	<script type="text/wxtag-template">
		<style>
			.flex-container{
				display: flex;
				-webkit-box-align: center;
				align-items: center;
				-webkit-box-pack: justify;
				justify-content: space-between;
			}
			img{
			    border: 0;
    			vertical-align: middle;
				max-width: 100%;
			}
			.border.radius{
				border-radius: 4px;
			}
			.margint20{
				margin-top: 10px;
			}
			.marginh20{
				margin-left: 10px;
				margin-right: 10px;
			}
			.marginr10{
				margin-right: 5px;
			}
			.overflow-h{
				overflow: hidden;
			}
			.text-white{
				color: #fff;
			}
			.fs-11{
				font-size: 11px;
			}
			.fs-14{
				font-size: 14px;
			}
			.text-bolder{
				font-weight: bolder;
			}
			.text-limit1, .text-limit2{
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
			}
			.text-limit1{
				-webkit-line-clamp: 1;
			}
			.fs-12{
				font-size: 12px;
			}
			.pill.badge.red.reverse{
				display: inline-block;
				min-width: 20px;
				font-size: 12px;
				vertical-align: middle;
				white-space: nowrap;
				text-align: center;
				position: relative;
				border: 1px solid #ff4c48;
				border-radius: 500px;
			}
		</style>
		${content}
	<\/script>
</wx-open-launch-weapp>`;
		}
	}
};
</script>